import React from "react"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import { gql, useClient, useQuery } from "hooks/urql"

import CloudroomProvider from "./CloudroomProvider"
import StudentLayout from "./StudentLayout"
import TutorLayout from "./TutorLayout"

export type ErrorType = {
  message: string
  name: string
}

type ChimeCloudroomProps = {
  sessionId: string
  ghost: boolean
}

const ChimeCloudroom: React.FC<ChimeCloudroomProps> = ({
  sessionId,
  ghost,
}) => {
  const client = useClient()
  const [sessionResult] = useQuery({
    query: sessionQuery,
    client,
    variables: { id: sessionId, ghost },
  })

  return (
    <div className="min-h-screen overflow-auto bg-[#111] text-white">
      <WithLoadingIndicator result={sessionResult}>
        {({ data: { viewer, airtutorsSession } }) => (
          <CloudroomProvider
            session={airtutorsSession}
            localUser={viewer}
            ghost={ghost}
          >
            {viewer.type === "Tutor" ? <TutorLayout /> : <StudentLayout />}
          </CloudroomProvider>
        )}
      </WithLoadingIndicator>
    </div>
  )
}

export default ChimeCloudroom

const sessionQuery = gql`
  query airtutorsSessionQuery($id: ID!, $ghost: Boolean!) {
    viewer {
      id
      type
      ssoEmail
      ssoEnabled
      fullName
      phoneNumber
      superadmin
    }
    airtutorsSession(id: $id) {
      id
      startsAt
      endsAt
      postSessionRedirectPath
      googledocPending
      googledocUrl
      realtimeboardPending
      realtimeboards {
        id
      }
      statusState
      studyGroup {
        id
      }
      students {
        id
      }
      studentCloudroomLink
      lowBandwidthCloudroom
      studentCamerasRequired
      studentScreenShareDisabled
      audioMutedUserIds
      videoMutedUserIds
      controlsLockedUserIds
      screenShareRejectedStudentIds
      missingTutor
      persistSessionTranscript
      tutorCaptionsEnabled
      copilotEnabled
      survey {
        id
      }
      chimeJoinInfo(ghost: $ghost) {
        attendee {
          attendeeId
          capabilities
          externalUserId
          joinToken
        }
        meeting
      }
    }
  }
`
